import * as Analytics from "./lib/TrellisAnalytics";
import * as React from "react";
import App from "./components/App";
import ErrorBoundary from "./components/ErrorBoundary";
import Logger from "./lib/Logger";
import { USER_INTENT } from "./lib/constants";
import { Warning } from "./lib/errors/api";
import { batch } from "react-redux";
import { fullReset } from "./store/actions";
import { onClose } from "./messages";
import useAppDispatch from "./hooks/useAppDispatch";
import useInitFeatureFlags from "./features/feature-flags/hooks/useInitFeatureFlags";
import useMemoryHistory from "./hooks/useMemoryHistory";
function onError(error, componentStack) {
    Analytics.javascriptError(error, componentStack);
    if (error instanceof Warning) {
        Logger.warning(error, { componentStack: componentStack });
    }
    else {
        Logger.error(error, { componentStack: componentStack });
    }
}
function Root() {
    var _a = React.useState(0), errorKey = _a[0], setErrorKey = _a[1];
    var _b = useMemoryHistory(), entries = _b.entries, push = _b.push;
    var dispatch = useAppDispatch();
    useInitFeatureFlags();
    function onErrorClose() {
        batch(function () {
            setErrorKey(function (prev) { return prev + 1; });
            dispatch(fullReset());
        });
        // if the user immediately tries to re-open the modal, we want to return them to the
        // start of their journey
        if (entries[0]) {
            push(entries[0]);
        }
        onClose(null, { userIntent: USER_INTENT.CLOSE });
    }
    return (React.createElement(ErrorBoundary, { key: errorKey, onError: onError, onCloseRequested: onErrorClose },
        React.createElement(App, null)));
}
export default Root;
